import Request from "@/common/net/request.js";
const request = new Request();
// 列表
export function getPage(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/page`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 出账
export function reconcile(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/reconcile`,
    method: "put",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情中的订单列表
export function reconciliationOrders(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/info/orders`,
    method: "post",
    data,
    config: {
      headers: {
        "Content-Type": "application/json"
      }
    }
  });
}

// 对账单详情
export function reconciliationOrderDetail(data) {
  return request.send({
    url: `/pmy/freight/reconciliation/order/info?billId=${data.billId}`,
    method: "get",
  });
}
